import Dialog from '@mui/material/Dialog';
import Fade from '@mui/material/Fade';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import './welcome-modal.scss';
import { PNGS } from '../../assets';
import {
  dispatch,
  getWorkspace,
  updateShowAgentWorkingModal,
  updateShowOnboardingDialogSignup,
  useAppSelector,
} from '@zonofi/seller-rtk-store';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';
import { SIGNUP_ONBOARDING } from '@zonofi/gandalf-utilities';
import { useNavigate } from 'react-router-dom';

const FadeTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Fade ref={ref} {...props} timeout={500} />;
});

export const WelcomeModal: React.FC<{
  open: boolean;
  isSampleFileLoadError: boolean;
  retrain: () => void;
}> = ({ open, isSampleFileLoadError, retrain }) => {
  const navigate = useNavigate();
  const workspace = useAppSelector(getWorkspace);
  return (
    <Dialog
      open={open}
      TransitionComponent={FadeTransition}
      PaperProps={{
        sx: {
          borderRadius: '32px',
        },
      }}
    >
      <div className="welcome-modal">
        <img src={PNGS.WelcomeModalImage} alt="" width={157} height={140} />
        <div className="welcome-modal-content">
          <div className="welcome-modal-content-greeting">
            <span className="welcome-modal-content-greeting-text primary-font-regular">
              Hello!{' '}
              <span role="img" aria-label="wave">
                👋
              </span>
            </span>
            <span className="welcome-modal-content-greeting-company primary-font-bold">
              {workspace?.businessDetails?.companyName}
            </span>
          </div>
          <div className="welcome-modal-content-description primary-font-regular">
            <span className="primary-font-semibold">Welcome to ZöTok.</span> You
            have successfully registered as a seller.
          </div>
        </div>
        {isSampleFileLoadError && (
          <div className="welcome-modal-error-strip">
            <span className="welcome-modal-error-strip-text primary-font-regular">
              There was an error loading the sample file. Please try again later
              or retrain using your own data.
            </span>
            <div className="welcome-modal-error-strip-buttons">
              <ZoButton
                label={'Retry'}
                onClick={() => {
                  retrain();
                }}
                className="welcome-modal-retry-button"
              />
              <ZoButton
                label={'Upload file'}
                onClick={() => {
                  navigate(SIGNUP_ONBOARDING.RETRAIN_AGENT.path);
                  dispatch(updateShowOnboardingDialogSignup(false));
                }}
                className="welcome-modal-upload-button"
              />
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};
